import React from "react";
import { CostProfileCostsHistory } from "@planzone/dto";
import { useRetrieveCostProfileCostsHistory } from "@planzone/view-models";
import { events } from "@planzone/events";
import { useMessage } from "@components/useMessage";
import { Props } from "./types";
import { Cost } from "./cost";
import styles from "./styles.scss";

function sort(
  current: CostProfileCostsHistory[number],
  next: CostProfileCostsHistory[number],
) {
  return new Date(current.startDate) < new Date(next.startDate) ? 1 : -1;
}

function CostHistory({ costProfile }: Props) {
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    history,
    retrieveCostProfileCostsHistory,
  } = useRetrieveCostProfileCostsHistory(costProfile);

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveCostProfileCostsHistory(costProfile);
  }, []);

  useMessage(
    ({ type, data }) =>
      type === events.editCostProfileSucceeded &&
      data.uuid === costProfile.uuid &&
      retrieveCostProfileCostsHistory(costProfile),
  );

  return (
    <div className={styles.costHistory}>
      <ul className={styles.list}>
        {[...[...history].sort(sort)].reverse().map((cost) => (
          <li key={cost.uuid}>
            <Cost cost={cost} />
          </li>
        ))}
      </ul>
    </div>
  );
}

export { CostHistory };
